import axios from "axios";
import { getUrl } from "@/common/config";
export default class AnalyticsApi {
  constructor(organizationCode) {
    // Get org id from passed in var
    this.organizationCode = organizationCode || localStorage.organizationCode;
    this.url = getUrl();
  }

  get organizationCode() {
    if (!this.orgCode) {
      this.organizationCode = localStorage.organizationCode;
    }
    return this.orgCode;
  }

  set organizationCode(newValue) {
    this.orgCode = newValue || localStorage.organizationCode;
  }

  /**
   * Get machines analytics
   * Params:
   * @param {array} machineids array machine Id, separate BY COMMA "id1,id2"
   * @param {string} from datetime string, optional date 'YYYY-MM-DD'
   * @param {string} to  datetime string, optional date 'YYYY-MM-DD'
   * @param {string} kpiCalcMethod string, enum REQUIRED
   * @returns {Array} promise with analytics
   */
  async getAnalyticsByMachines({ machines, from = "", to = "", kpiCalcMethod }) {
    const params = {
      from,
      to,
      kpiCalcMethod,
      machineIds: machines.map(item => item.Id).join(",")
    };

    return axios.get(`${this.url}/api/v2/machines/analytics`, { params }).then(response => {
      return response.data.result;
    });
  }

  /**
   * Get machines analytics
   * Params:
   * @param {string} machineId
   * @param {string} from datetime string, optional
   * @param {string} to  datetime string, optional
   * @param {string} kpiCalcMethod string
   * @returns {Array} promise with analytics
   */
  async getAnalyticsByMachineId({ machineId, from = "", to = "", kpiCalcMethod }) {
    const params = {
      from,
      to,
      kpiCalcMethod,
      machines: [{ Id: machineId }]
    };
    const res = await this.getAnalyticsByMachines(params);

    return res;
  }

  /**
   * Get daily machines analytics
   * Params:
   * @param {string} machineId
   * @param {string} from datetime string
   * @param {string} to  datetime string
   * @returns {Array} promise with analytics
   */
  async getDailyAnalyticsByMachineId({ machineId, from = "", to = "", kpiCalcMethod }) {
    const params = {
      from,
      to,
      kpiCalcMethod
    };

    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/analytics`, { params })
      .then(response => {
        return response.data.result;
      });
  }
}
